/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {createDate as ɵa} from './create/date-from-array';